<template>
    <loading-box :loading="loading">
        <h2>Upcoming birthdays <small>(this month)</small></h2>

        <table class="table mt-8" v-if="birthdays.length > 0">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Client</th>
                    <th class="text-center">Date</th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="birthday in birthdays">
                    <!-- Name -->
                    <td style="vertical-align: middle;">
                        {{ birthday.name }}
                    </td>

                    <!-- Client -->
                    <td style="vertical-align: middle;">
                        {{ birthday.client_name }}
                    </td>

                    <!-- Date -->
                    <td style="vertical-align: middle;" class="text-center">
                        {{ birthday.day }} / {{ birthday.month }}
                    </td>
                </tr>
            </tbody>

            <tfoot>
                <tr>
                    <th>Name</th>
                    <th>Client</th>
                    <th class="text-center">Date</th>
                </tr>
            </tfoot>
        </table>
    </loading-box>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import LoadingBox from '@/components/LoadingBox'
    import Api from '@/api'

    export default {
        computed: {
           ...mapGetters({
              birthdays: 'birthdays/upcoming',
           })
        },

        data: () => ({
            loading: true,
        }),

        mounted() {
            if (this.birthdays.length == 0) {
                this.fetch().then(() => {
                    this.loading = false;
                });
            } else {
                this.loading = false;
            }
        },

        methods: {
            ...mapActions({ fetch: 'birthdays/fetch' }),
        },

        components: {
            'loading-box': LoadingBox
        }
    }
</script>
